import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import api from "@/lib/api";

const FALLBACK = {
  contact_email: "sanctioning@mastersproboxing.com",
  contact_phone: "+1 (800) 632-3400 — 24h Fighter Hotline",
  contact_address: "400 Championship Way, Las Vegas, NV 89101",
};

export default function Footer() {
  const [cfg, setCfg] = useState(FALLBACK);
  useEffect(() => {
    api.get("/site-config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);
  return (
    <footer className="border-t border-zinc-800/60 bg-[#0d0d0d]" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-5">
            <img src="/images/mpb-shield.png" alt="Masters Pro Boxing" className="h-10 w-10 object-contain" />
            <span className="font-display text-2xl tracking-[0.15em] text-white">
              MASTERS <span className="text-[#E10600]">PRO</span> BOXING
            </span>
          </div>
          <p className="text-sm text-zinc-400 leading-relaxed max-w-sm">
            The official professional boxing organization for veteran fighters aged 40–55.
            Experience never retires.
          </p>
          <p className="font-mono2 text-[10px] tracking-[0.35em] text-zinc-500 uppercase mt-5">
            Founder — <span className="text-[#E10600]">Manindar Singh</span>
          </p>
          <p className="font-mono2 text-[10px] tracking-[0.35em] text-zinc-500 uppercase mt-2" data-testid="footer-ibc-line">
            Affiliated with IBC — Indian Boxing Council
          </p>
        </div>
        <div className="md:col-span-4">
          <h4 className="font-mono2 text-[10px] tracking-[0.4em] text-zinc-500 uppercase mb-6">Contact</h4>
          <ul className="space-y-4 text-sm text-zinc-300">
            <li className="flex items-center gap-3">
              <Mail className="h-4 w-4 text-[#E10600] shrink-0" />
              <a href={`mailto:${cfg.contact_email}`} data-testid="footer-email-link" className="hover:text-white transition-colors">
                {cfg.contact_email}
              </a>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#E10600] shrink-0" />
              <span data-testid="footer-phone">{cfg.contact_phone}</span>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="h-4 w-4 text-[#E10600] shrink-0" />
              <span data-testid="footer-address">{cfg.contact_address}</span>
            </li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <h4 className="font-mono2 text-[10px] tracking-[0.4em] text-zinc-500 uppercase mb-6">MPB</h4>
          <ul className="space-y-3 text-sm">
            <li><a href="/#about" data-testid="footer-link-about" className="text-zinc-300 hover:text-[#E10600] transition-colors">About the MPB</a></li>
            <li><a href="/#faq" data-testid="footer-link-medical" className="text-zinc-300 hover:text-[#E10600] transition-colors">Medical Protocols</a></li>
            <li><a href="/#divisions" data-testid="footer-link-divisions" className="text-zinc-300 hover:text-[#E10600] transition-colors">Weight Divisions</a></li>
            <li><Link to="/register" data-testid="footer-link-register" className="text-zinc-300 hover:text-[#E10600] transition-colors">Fighter Registration</Link></li>
            <li><Link to="/login" data-testid="footer-link-login" className="text-zinc-300 hover:text-[#E10600] transition-colors">Fighter Login</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono2 text-[10px] tracking-[0.25em] text-zinc-600 uppercase">
            © 2026 Masters Pro Boxing. All rights reserved.
          </p>
          <div className="flex items-center gap-3" data-testid="ggk-credit">
            <img src="/images/ggk-band.jpeg" alt="GGK Fight Club" className="h-8 w-auto object-contain rounded-sm" />
            <span className="font-mono2 text-[10px] tracking-[0.25em] text-zinc-600 uppercase">
              Powered by <span className="text-[#D4AF37]">GGK Fight Club</span>
            </span>
          </div>
          <p className="font-mono2 text-[10px] tracking-[0.25em] text-zinc-600 uppercase">
            Experience Never Retires
          </p>
        </div>
      </div>
    </footer>
  );
}
